import pubsub from "sweet-pubsub";
import { createContacts } from '../../domain/call/contact.action';
import sessionStore from '../../store/session';
import { get } from "svelte/store";
import toast from "../toast";
let phoneNumber = null;
let client;
function resizeApp() {
    const dimension = { height: '460px', width: '320px' };
    console.log("dimension", dimension);
    client.instance.resize(dimension);
}
export const showApp = () => {
    client.interface.trigger("show", { id: "softphone" }).then(function () {
        console.log(`Success: Opened the app`);
    }).catch(function (error) {
        console.error('Error: Failed to open the app');
        console.error(error);
    });
};
export const hideApp = () => {
    client.interface.trigger("hide", { id: "softphone" }).then(function (data) {
        console.info('successfully closed the CTI app');
        toast.success('Successfully closed the CTI app.');
    }).catch(function (error) {
        console.error('Error: Failed to close the CTI app');
        console.error(error);
    });
};
export const showMissedCall = () => {
    client.interface.trigger("show", { id: "missedCall", value: missedCalls })
        .then(function (data) {
        console.info('successfully shown missed calls.', data);
    }).catch(function (error) {
        console.error('Error: failed to show missed calls.', error);
    });
};
export const hideMissedCall = () => {
    client.interface.trigger("hide", { id: "missedCall" })
        .then(function (data) {
        console.info('successfully hidden missed calls');
    }).catch(function (error) {
        console.error('Error: failed to hide missed calls');
        console.error(error);
    });
};
function clickToCall() {
    client.events.on("cti.triggerDialer", function (event) {
        var data = event.helper.getData();
        phoneNumber = data.number;
        showApp();
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
    });
}
export function syncContacts() {
    const url = 'https://<%= iparam.freshdesk_domain %>/api/v2/contacts';
    const options = {
        headers: {
            Authorization: 'Basic <%= encode(iparam.freshdesk_api_key) %>'
        }
    };
    return new Promise((resolve, reject) => {
        client.request.get(url, options).then(async (contacts) => {
            const response = JSON.parse(contacts.response);
            const uploads = [];
            for (let i = 0; i < response.length; i++) {
                const { name, phone, email, job_title, address } = response[i];
                uploads.push({
                    name: name,
                    number: phone,
                    email: email,
                    company: "",
                    job_title: job_title,
                    address: address
                });
            }
            const { profile } = get(sessionStore);
            if (uploads.length > 0) {
                await createContacts(profile.business.id, uploads);
            }
            resolve("done");
        }, error => {
            console.error(error);
            return reject(error);
        });
    });
}
export function getContacts() {
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    console.log(client.iparams.get());
    console.log(client.data.get("domainName"));
    console.log(client.data.get("loggedInUser"));
    const url = 'https://<%= iparam.freshsales_domain %>/api/v2/contacts';
    const options = {
        headers: {
            Authorization: 'Basic <%= encode(iparam.freshsales_api_key) %>'
        }
    };
    client.request.get(url, options).then(contacts => {
        console.info('Success: Got contacts list');
        console.table(JSON.parse(contacts.response));
        return JSON.parse(contacts.response);
    }, error => {
        console.error(error);
        return error;
    });
}
export function createContact({ name, email, phone }) {
    const properties = {
        name,
        email,
        phone,
    };
    const url = 'https://<%= iparam.freshdesk_domain %>/api/v2/contacts';
    const options = {
        headers: {
            Authorization: 'Basic <%= encode(iparam.freshdesk_api_key) %>'
        },
        json: properties
    };
    client.request.post(url, options).then(contact => {
        console.info('Success: Created contact');
        console.info(contact.response);
        const { id } = contact.response;
        if (id) {
            navigate(id);
        }
    }, error => {
        console.error('Error: Failed to create contact');
        console.error(error);
    });
}
function navigate(contactId) {
    client.interface.trigger("click", { id: "contact", value: contactId })
        .then(function (data) {
        console.info('successfully navigated to contact');
    }).catch(function (error) {
        console.error('Error: Failed to navigate to contact');
        console.error(error);
    });
}
function onAppActivate() {
    console.log("hello from pressone");
    resizeApp();
    clickToCall();
    getContacts();
}
pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
    console.log("user logged in", phoneNumber);
    if (phoneNumber) {
        pubsub.emit('initiate_call', phoneNumber);
    }
});
pubsub.on('number_selected', ({}) => {
    if (phoneNumber) {
        pubsub.emit('initiate_call', phoneNumber);
    }
});
export function useCti() {
    window.onload = function () {
        console.log(">>>>>>>>>>>>>>>>>>>>>> initializing freshsales >>>>>>>>>>>>>>>>>>>", window);
        initializeApp();
    };
}
const initializeApp = () => {
    var onInit = window.app.initialized();
    console.log("onInit", onInit);
    onInit.then(getClient).catch(console.error);
    function getClient(_client) {
        window.client = _client;
        console.log("_client", _client);
        client.events.on('app.activated', onAppActivate);
    }
};
